import type { InboxIndicationColorResponseDto } from '@api'

export type ColorWithPrice = InboxIndicationColorResponseDto & {
  price: number
}

type Colors = Record<string, InboxIndicationColorResponseDto> | null

export const transformSpendColorsToArray = (
  defaultColor: InboxIndicationColorResponseDto,
  data?: Colors,
) => {
  if (!data || !defaultColor) {
    return null
  }

  const transformedData: ColorWithPrice[] = Object.entries(data).map(
    ([spend, colorVariant]) => ({
      ...colorVariant,
      price: parseInt(spend, 10),
    }),
  )

  // Default Color
  transformedData.unshift({ ...defaultColor, price: 0 })

  return transformedData
}

export interface ColorWithIndex extends ColorWithPrice {
  index: number
}
